import * as React from 'react';

import {
    Grid,
    Paper,
    Box,
    Button,
    Typography,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../../api/ApiCall";
import { v4 as uuidv4 } from 'uuid';
import { useUtilityContext } from '../../../utility-provider';
import { useUserContext } from '../../../user-provider';
import useSound from 'use-sound';
import beep_2 from '../../../sound/beep_2.mp3';
import move_2 from '../../../sound/move_2.mp3';
import decision_2 from '../../../sound/decision_2.mp3';
import decision_31 from '../../../sound/decision_31.mp3';
import decision_38 from '../../../sound/decision_38.mp3';
import decision_48 from '../../../sound/decision_48.mp3';
import alarm_1 from '../../../sound/alarm_1.mp3';
import ConfirmDialog from './ConfirmDialog';
import ErrorConfirmDialog from '../../common/ConfirmDialog';
import RefreshIcon from '@mui/icons-material/Refresh';
import Reset from '../../common/Reset'
import { hasScroll } from "../../common/Scroll";
import { encryptQueryParam, decryptQueryParam } from '../../../utility/util';
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';

export interface resultProps {
    props:{
    }
}

const defaultCountList = {
    'car_total': 0,
    'car_front_standard': 0,
    'car_front_light': 0,
    'car_front_large': 0,
    'car_side_a_standard': 0,
    'car_side_a_light': 0,
    'car_side_a_large': 0,
    'car_side_b_standard': 0,
    'car_side_b_light': 0,
    'car_side_b_large': 0,
    'car_back_standard': 0,
    'car_back_light': 0,
    'car_back_large': 0,
    'people_total': 0,
    'people_5m_in_male_65over': 0,
    'people_5m_in_female_65over': 0,
    'people_5m_in_male_other': 0,
    'people_5m_in_female_other': 0,
    'people_5m_in_student': 0,
    'people_5m_in_bicycle': 0,
    'people_5m_out_male_65over': 0,
    'people_5m_out_female_65over': 0,
    'people_5m_out_male_other': 0,
    'people_5m_out_female_other': 0,
    'people_5m_out_student': 0,
    'people_5m_out_bicycle': 0,
};

const carCount = () => {
    return [
        { 'label': '前面', 'key': 'front', 'standard': 'car_front_standard', 'light': 'car_front_light', 'large': 'car_front_large' },
        { 'label': '側A', 'key': 'side_a', 'standard': 'car_side_a_standard', 'light': 'car_side_a_light', 'large': 'car_side_a_large' },
        { 'label': '側B', 'key': 'side_b', 'standard': 'car_side_b_standard', 'light': 'car_side_b_light', 'large': 'car_side_b_large' },
        { 'label': '裏道', 'key': 'back', 'standard': 'car_back_standard', 'light': 'car_back_light', 'large': 'car_back_large' },
    ]
}

const peopleCount = () => {
    return [
        { 'label': '5M内', 'male': 'people_5m_in_male_65over', 'female': 'people_5m_in_female_65over', 's_b': 'people_5m_in_student' },
        { 'label': '5M内', 'male': 'people_5m_in_male_other', 'female': 'people_5m_in_female_other', 's_b': 'people_5m_in_bicycle' },
        { 'label': '5M外', 'male': 'people_5m_out_male_65over', 'female': 'people_5m_out_female_65over', 's_b': 'people_5m_out_student' },
        { 'label': '5M外', 'male': 'people_5m_out_male_other', 'female': 'people_5m_out_female_other', 's_b': 'people_5m_out_bicycle' },
    ]
}

const peopleCount2 = () => {
    return [
        { 'label': '5M内', 'male': 'people_5m_in_male_65over', 'female': 'people_5m_in_female_65over', 's_b': 'people_5m_in_student' },
        { 'label': '5M内', 'male': 'people_5m_in_male_other', 'female': 'people_5m_in_female_other', 's_b': 'people_5m_in_bicycle' },
    ]
}

const TrafficVolume:React.FC<resultProps> = ({props}) => {

    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const navigate = useNavigate();

    const [planAreaId, setPlanAreaId] = React.useState<string>("");
    const [referrer, setReferrer] = React.useState<string>("");
    const [measurementTime, setMeasurementTime] = React.useState<number>(0);
    const [measurementType, setMeasurementType] = React.useState<string>("");

    const [countList, setCountList] = React.useState(defaultCountList);
    const [checked, setChecked] = React.useState(true);
    const [counter, setCounter] = React.useState(false);
    const [counterStart, setCounterStart] = React.useState(false)
    const [countTimer, setCountTimer] = React.useState<number>(0)
    const [countStart, setCountStart] = React.useState(false)
    const [trafficJamTime, setTrafficJamTime] = React.useState<number>(0)
    const [trafficJamStart, setTrafficJamStart] = React.useState(false)
    const [sideTrafficJamTime, setSideTrafficJamTime] = React.useState<number>(0)
    const [sideTrafficJamStart, setSideTrafficJamStart] = React.useState(false)
    const [countDate, setCountDate] = React.useState<Date>()
    const [sound_beep_2] = useSound(beep_2);
    const [sound_move_2] = useSound(move_2);
    const [sound_decision_2] = useSound(decision_2);
    const [sound_decision_31] = useSound(decision_31);
    const [sound_decision_38] = useSound(decision_38);
    const [sound_decision_48] = useSound(decision_48);
    const [sound_alarm_1] = useSound(alarm_1);
    const [open, setOpen] = React.useState<boolean>(false);
    const [confirmMode, setConfirmMode] = React.useState<string>("");
    const [confirmBody, setConfirmBody] = React.useState<string>("");
    const [confirmCancelButton, setConfirmCancelButton] = React.useState<string>("");
    const [confirmRestartButton, setConfirmRestartButton] = React.useState<string>("");
    const [confirmOkButton, setConfirmOkButton] = React.useState<string>("");
    const [confirmCancelRegistButton, setConfirmCancelRegistButton] = React.useState<string>("");

    const [openReset, setOpenReset] = React.useState<boolean>(false)
    const [arbitraryMeasurement, setArbitraryMeasurement] = React.useState<boolean>(false)
    const [arbitraryCount, setArbitraryCount] = React.useState<number>(0)

    // ダイアログ開閉フラグ
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);

    // iPhone判定
    const [isIPhone, setIsIPhone] = React.useState<boolean>(false);

    React.useEffect(() => {
        // iPhone判定（User Agentベース、開発者ツールにも対応）
        const userAgent = window.navigator.userAgent;
        const isiPhoneDevice = /iPhone/.test(userAgent);
        setIsIPhone(isiPhoneDevice);
    }, []);

    React.useEffect(() => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        hasScroll();
        let date = new Date();
        setCountDate(date);
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            if (res[0] && res[0].trim() !== '') {
                setPlanAreaId(res[0]);
                setReferrer(res[1]);
                setMeasurementTime(Number(res[2]));
                setMeasurementType(res[3]);
                setCountTimer(Number(res[2]) * 60);

                // 画面表示 userLogging
                if (user.userData) {
                    const decryptedUrl = window.location.pathname + `?planAreaId=${res[0]}&referrer=${res[1]}&measurementTime=${res[2]}&measurementType=${res[3]}`;
                    const encryptedUrl = window.location.pathname + window.location.search;
                    userLogging(
                        LOCAL_CONSTANT.FUNCTION_NAME.TRAFFIC_VOLUME_REGIST_DISPLAY,
                        {
                            decrypted_url: decryptedUrl,
                            encrypted_url: encryptedUrl
                        },
                        user
                    );
                }
            } else {
                // planAreaIdが存在しない場合はダイアログを表示
                setErrorDialogOpen(true);
            }
        }).catch((e:any) => {
            console.log(e);
            // 復号化エラーの場合もダイアログを表示
            setErrorDialogOpen(true);
        }).finally(() => {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }, []);

    React.useEffect(() => {
        const copyData = JSON.parse(JSON.stringify(defaultCountList));
        setCountList(copyData);
    }, [measurementType]);

    const CountItem = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: 'center',
        border: '2px solid #F00',
        display: 'grid',
        placeItems: 'center',
        width: '100%',
    }));
    const ItemLabel = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: 'center',
        display: 'grid',
        placeItems: 'center',
        boxShadow: 'none',
    }));
    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        border: '2px solid #ffa500',
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        color: '#FFF',
        backgroundColor: '#ffa500',
    }));


    const setCount = (key: string) => {
        if (counterStart && countList) {
            const tmp:any[] = [];
            tmp.push(countList)
            if (checked) {
                // +
                tmp[0][key] = tmp[0][key] + 1
                if (key.indexOf('car') >= 0) {
                    tmp[0]['car_total'] = tmp[0]['car_total'] + 1
                } else {
                    if (key.indexOf('bicycle') === -1) {
                        tmp[0]['people_total'] = tmp[0]['people_total'] + 1
                    }
                }

                if (key.includes('front')) {
                    sound_move_2(); 
                } else if (key.includes('side')) {
                    sound_decision_48();
                } else if (key.includes('back')) {
                    sound_decision_48();
                } else if (key.includes('5m_in')) {
                    sound_decision_2();
                } else if (key.includes('5m_out')) {
                    sound_decision_38();
                }
            } else {
                // -
                if (tmp[0][key] > 0) {
                    tmp[0][key] = tmp[0][key] - 1
                    if (key.indexOf('car') >= 0) {
                        tmp[0]['car_total'] = tmp[0]['car_total'] - 1
                    } else {
                        if (key.indexOf('bicycle') === -1) {
                            tmp[0]['people_total'] = tmp[0]['people_total'] - 1
                        }
                    }
                }

                sound_beep_2();
            }

            setCounter(!counter)
            setCountList(tmp[0])
        }

        return
    };

    const getCount = (key: string) => {
        const tmp:any[] = [];
        tmp.push(countList)
        return tmp[0][key]
    }

    const carDisplay = () => {
        return ["0", "3"].includes(measurementType)
        ? { margin: "0 10px", display: 'block' } 
        : measurementType === "1"  ? { margin: "15px 10px", display: 'block' } :{ display: 'none' }
    }

    const peopleDisplay = () => {
        return ["0", "3"].includes(measurementType)
        ? { margin: "8px 10px", display: 'block' } 
        : measurementType === "2"  ? { margin: "30px 10px", display: 'block' } :{ display: 'none' }
    }

    const peopleList = () => {
        return ["0", "2"].includes(measurementType)
        ? peopleCount()
        : measurementType === "3" ? peopleCount2() : []
    }
    
    const setMargin = () => {
        return ["0", "3"].includes(measurementType) ? { marginBottom: "0" } : { margin: "30px 0" }
    }

    // 測定開始
    const checkCounterStart = () => {
        if (!checkParam()) {
            if (counterStart === false) {
                setCounterStart(true)
                setCountStart(true)
                // 測定開始時間再登録
                let date = new Date();
                setCountDate(date)
            }
        }
    }

    // パラメータチェック
    const checkParam = () => {
        let hasError = false
        if (
            planAreaId == "" ||
            Number.isNaN(measurementTime) ||
            measurementType == ""
        ) {
            // 候補地Noがない
            // 計測時間が数値ではない
            // 測定種別がない
            settingBody('unexpectedError')
            setConfirmRestartButton("")
            setConfirmCancelButton("")
            setConfirmOkButton("OK")
            setConfirmCancelRegistButton("")
            setConfirmMode("unexpected_error")
            setCountStart(false)
            setTrafficJamStart(false)
            setSideTrafficJamStart(false)
            setOpen(true)
            hasError = true
        }
        return hasError
    }
    
    // -+の切替
    function handleClick() {
        setChecked(!checked)
    }

    // 計測カウントダウン
    React.useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (countStart) {
                if (countTimer === 0 && !arbitraryMeasurement) {
                    clearInterval(countDownInterval)
                    onClickHandle("end_count_time")
                } else if (countTimer && countTimer > 0) {
                    setCountTimer(countTimer - 1)
                }
            } else {
                clearInterval(countDownInterval)
            }
        }, 1000)
        return () => {
            clearInterval(countDownInterval)
        }
    }, [countTimer, countStart, arbitraryMeasurement])

    // 任意計測
    React.useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (arbitraryMeasurement) {
                setArbitraryCount(arbitraryCount + 1)
            } else {
                clearInterval(countDownInterval)
            }
        }, 1000)
        return () => {
            clearInterval(countDownInterval)
        }
    }, [arbitraryCount, arbitraryMeasurement])

    // 前面渋滞カウントアップ
    React.useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (trafficJamStart) {
                setTrafficJamTime(trafficJamTime + 1)
            }
        }, 1000)
        return () => {
            clearInterval(countDownInterval)
        }
    }, [trafficJamTime, trafficJamStart])

    const trafficJam = () => {
        if (counterStart) {
            sound_decision_31();
            setTrafficJamStart(!trafficJamStart)
        }
    }

    // 側A渋滞カウントアップ
    React.useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (sideTrafficJamStart) {
                setSideTrafficJamTime(sideTrafficJamTime + 1)
            }
        }, 1000)
        return () => {
            clearInterval(countDownInterval)
        }
    }, [sideTrafficJamTime, sideTrafficJamStart])

    const sideTrafficJam = () => {
        if (counterStart) {
            sound_decision_31();
            setSideTrafficJamStart(!sideTrafficJamStart)
        }
    }

    const displayDate = () => {
        let date = ""
        const dayname = ['日','月','火','水','木','金','土'];

        if (countDate) {
            date = countDate.getFullYear().toString().substring(2, 4)
            + "/" + (countDate.getMonth() + 1).toString().padStart(2, "0")
            + "/" + (countDate.getDate()).toString().padStart(2, "0")
            + "(" + dayname[countDate.getDay()] + ")"
        }

        return date
    }

    const displayCountDateTime = () => {
        let date = ""

        if (countDate && counterStart) {
            date =  countDate.getHours().toString().padStart(2, "0")
            + ":" + countDate.getMinutes().toString().padStart(2, "0") + "～"
        }

        return date
    }

    const setLabel = (indexLabel: string, index: number, position: string) => {
        let label = ""
        switch(position) {
            case 'left':
                label = indexLabel + " 65上男"
                if ((index % 2) === 1) {
                    label = indexLabel + " その他男"
                }
                break;
            case 'center':
                label = indexLabel + " 65上女"
                if ((index % 2) === 1) {
                    label = indexLabel + " その他女"
                }
                break;
            case 'right':
                label = indexLabel + " 中高生"
                if ((index % 2) === 1) {
                    label = indexLabel + " 自転車"
                }
                break;
        }

        return label
    }

    const counterPadding = (target: string) => {
        let padding = ''
        switch(target) {
            case 'box':
                padding = '0'
                break;
            case 'label':
                padding = ["0", "3"].includes(measurementType) ? '2px' : '12px'
                break;
        }

        return padding
    }

    const displayTrafficJamTime = (time : any) => {
        const minute = Math.floor(time / 60)
        return minute + ':' + (time - (minute * 60)).toString().padStart(2, "0")
    }

    const settingBody = (type: string) => {
        let body = ""
        switch (type) {
            case  'back':
            case  'regist':
            case  'end_count_time':
                body = "現在の計測結果\n";
                if (measurementType === '0') {
                    body += "車："+countList.car_total+"\n人："+countList.people_total
                } else if (measurementType === '1') {
                    body += "車："+countList.car_total
                } else if (measurementType === '2') {
                    body += "人："+countList.people_total
                }
                break;
            case 'cancelConfirm':
                body = "計測結果を保存せずに\n終了してもよろしいですか";
                break;
            case 'finishRegist':
                body = "保存が完了しました";
                break;
            case 'errorRegist':
                body = "保存に失敗しました";
                break;
            case 'unexpectedError':
                body = "計測に必要な情報がクリアされました。\n候補地選択からやり直してください";
                break;
        }

        setConfirmBody(body)
    }

    const onClickHandle = (target: string) => {
        switch (target) {
            case "reset":
                clickReset()
                break;
            case "back":
            case "regist":
                settingBody('back')
                setConfirmRestartButton("再開")
                setConfirmCancelButton("中止")
                setConfirmOkButton("保存")
                setConfirmCancelRegistButton("")
                setConfirmMode("back")
                setCountStart(false)
                setTrafficJamStart(false)
                setSideTrafficJamStart(false)
                setOpen(true)
                break;
            case "back_restart":
                setCountStart(true)
                setOpen(false)
                break;
            case "back_cancel":
                settingBody('cancelConfirm')
                setConfirmRestartButton("")
                setConfirmCancelButton("いいえ")
                setConfirmOkButton("")
                setConfirmCancelRegistButton("はい")
                setConfirmMode("cancelConfirm")
                break;
            case "back_regist":
                onRegist()
                break;
            case "end_count_time":
                sound_alarm_1()
                settingBody('end_count_time')
                setConfirmRestartButton("")
                setConfirmCancelButton("キャンセル")
                setConfirmOkButton("任意計測")
                setConfirmCancelRegistButton("保存")
                setConfirmMode("end_count_time")
                setCountStart(false)
                setTrafficJamStart(false)
                setSideTrafficJamStart(false)
                setOpen(true)
                break;
            case "finishiArbitrary":
                settingBody('regist')
                setConfirmRestartButton("")
                setConfirmCancelButton("キャンセル")
                setConfirmOkButton("")
                setConfirmCancelRegistButton("保存")
                setConfirmMode("finishiArbitrary")
                setCountStart(false)
                setTrafficJamStart(false)
                setSideTrafficJamStart(false)
                setOpen(true)
                break;
            case "finishiArbitrary_cancel":
                settingBody('cancelConfirm')
                setConfirmRestartButton("")
                setConfirmCancelButton("いいえ")
                setConfirmOkButton("")
                setConfirmCancelRegistButton("はい")
                setConfirmMode("cancelConfirm")
                break;
            case "finishiArbitrary_regist":
                onRegist()
                break;
            case "end_count_time_cancel":
                settingBody('cancelConfirm')
                setConfirmRestartButton("")
                setConfirmCancelButton("いいえ")
                setConfirmOkButton("")
                setConfirmCancelRegistButton("はい")
                setConfirmMode("cancelConfirm")
                break;
            case "end_count_time_regist":
                onRegist()
                break;
            case "end_count_time_arbitraryMeasurement":
                arbitraryMeasurementStart()
                break;
            case "cancelConfirm_cancel":
                setCountStart(true)
                setOpen(false)
                break;
            case "cancelConfirm_regist":
                closeRegist()
                break;
            case "finish":
                settingBody('finishRegist')
                setConfirmRestartButton("")
                setConfirmCancelButton("")
                setConfirmOkButton("閉じる")
                setConfirmCancelRegistButton("")
                setConfirmMode("finish")
                setOpen(true)
                break;
            case "finish_regist":
                closeRegist()
                break;
            case "error":
                settingBody('errorRegist')
                setConfirmRestartButton("")
                setConfirmCancelButton("")
                setConfirmOkButton("閉じる")
                setConfirmCancelRegistButton("")
                setConfirmMode("error")
                setOpen(true)
                break;
            case "error_regist":
                closeRegist()
                break;
            case "unexpected_error_regist":
                if (process.env.REACT_APP_RVIEW_URL) {
                    window.location.href = process.env.REACT_APP_RVIEW_URL
                }
                break;
        }
    }

    // 任意計測開始
    const arbitraryMeasurementStart = () => {
        if (!checkParam()) {
            setCounterStart(true)
            setCountStart(true)
            setArbitraryMeasurement(true)
            setOpen(false)    
        }
    }

    const closeRegist = () => {
        setOpen(false);
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        let param = `planAreaId=${planAreaId}&referrer=${referrer}`;
        // URLパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            let url = "/TrafficVolume/select?" + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }

    // リセット関連
    const clickReset = () => {
        if (counterStart && !arbitraryMeasurement) {
            setOpenReset(true)
        }
    }

    const cancelReset = () => {
        setOpenReset(false)
    }

    const registReset = () => {
        setCounterStart(false)
        setCountStart(false)
        const copyData = JSON.parse(JSON.stringify(defaultCountList))
        setCountList(copyData)
        setCountTimer(measurementTime * 60)
        setOpenReset(false)
    }
    // リセット関連


    const onRegist = () => {
        let count_date = ""
        if (countDate) {
            count_date = countDate.getUTCFullYear() + "-" +
            (countDate.getUTCMonth() + 1).toString().padStart(2, "0") + "-" +
            countDate.getUTCDate().toString().padStart(2, "0") + " " +
            (countDate.getUTCHours() + 9).toString().padStart(2, "0") + ":" +
            countDate.getUTCMinutes().toString().padStart(2, "0") + ":" +
            countDate.getUTCSeconds().toString().padStart(2, "0") + "." +
            // ミリ秒処理が0の場合はDB登録時に捨てられるため、001にする
            (countDate.getUTCMilliseconds() === 0 ? "001" : countDate.getUTCMilliseconds().toString().padStart(3, "0"))
        }

        const params = {
            mode: "postRequest",
            endPoint: "/location/TrafficVolume/v1/regist",
            query: {
                uuid: uuidv4(),
                plan_area_id: planAreaId.toString(),
                count_date: count_date.toString(),
                count_time: measurementTime.toString(),
                front_traffic_jam_time: (Math.round((trafficJamTime / 60) * 100) / 100).toString(),
                side_a_traffic_jam_time: (Math.round((sideTrafficJamTime / 60) * 100) / 100).toString(),
                count_type: measurementType.toString() === "3" ? "0" : measurementType.toString(),
                car_front_standard: countList.car_front_standard.toString(),
                car_front_light: countList.car_front_light.toString(),
                car_front_large: countList.car_front_large.toString(),
                car_side_a_standard: countList.car_side_a_standard.toString(),
                car_side_a_light: countList.car_side_a_light.toString(),
                car_side_a_large: countList.car_side_a_large.toString(),
                car_side_b_standard: countList.car_side_b_standard.toString(),
                car_side_b_light: countList.car_side_b_light.toString(),
                car_side_b_large: countList.car_side_b_large.toString(),
                car_back_standard: countList.car_back_standard.toString(),
                car_back_light: countList.car_back_light.toString(),
                car_back_large: countList.car_back_large.toString(),
                people_5m_in_male_65over: countList.people_5m_in_male_65over.toString(),
                people_5m_in_female_65over: countList.people_5m_in_female_65over.toString(),
                people_5m_in_male_other: countList.people_5m_in_male_other.toString(),
                people_5m_in_female_other: countList.people_5m_in_female_other.toString(),
                people_5m_in_student: countList.people_5m_in_student.toString(),
                people_5m_in_bicycle: countList.people_5m_in_bicycle.toString(),
                people_5m_out_male_65over: countList.people_5m_out_male_65over.toString(),
                people_5m_out_female_65over: countList.people_5m_out_female_65over.toString(),
                people_5m_out_male_other: countList.people_5m_out_male_other.toString(),
                people_5m_out_female_other: countList.people_5m_out_female_other.toString(),
                people_5m_out_student: countList.people_5m_out_student.toString(),
                people_5m_out_bicycle: countList.people_5m_out_bicycle.toString(),
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                let countTime = measurementTime * 60 - countTimer
                if (arbitraryMeasurement) {
                    countTime = measurementTime * 60 + countTimer + arbitraryCount
                } else {
                    if (countTime < 0) {
                        countTime = measurementTime * 60 + countTimer
                    }    
                }
                params.query.count_time = Math.floor(countTime / 60) > 0 ? Math.floor(countTime / 60).toString() : "1"
                // userLogging
                if (user.userData) {
                    userLogging(
                        LOCAL_CONSTANT.FUNCTION_NAME.TRAFFIC_VOLUME_SAVE,
                        params,
                        user
                    );
                }
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                onClickHandle("finish")
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                onClickHandle("error")
            }
        })();
    }

    return (
        <Box sx={{ width: "100%" }}>
            <ConfirmDialog 
                props={{
                    open:open,
                    handleModal:setOpen,
                    onRegist:onClickHandle,
                    mode:confirmMode,
                    body:confirmBody,
                    confirmRestart:confirmRestartButton,
                    confirmCancel:confirmCancelButton,
                    confirmOk:confirmOkButton,
                    confirmCancelRegist:confirmCancelRegistButton,
                }}
            />
            <Reset
                props={{
                    open: openReset,
                    handleModal: setOpenReset,
                    onCancel:cancelReset,
                    onExecution:registReset,
                }}
            />
            <Box sx={{ margin: '10px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                    <Box sx={{ display: 'flex', width: '90px' }}>
                        <Box>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{margin: '0', minWidth: '30px', padding: '10px 0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                                }}
                                onClick={(e) => {onClickHandle('back')}}
                            >≪</Button>
                        </Box>
                        <Box>
                            <Typography sx={{margin: '0', padding: '0 6px', fontSize: '0.8rem', whiteSpace: 'pre-wrap'}}>{displayDate()}</Typography>
                            <Typography sx={{margin: '0', padding: '0 6px', fontSize: '0.8rem', whiteSpace: 'pre-wrap'}}>{displayCountDateTime()}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ width: '100px' }}>
                        {
                            !arbitraryMeasurement &&
                            counterStart === false &&
                            <Item onClick={checkCounterStart}>計測開始</Item>
                        }
                        {
                            !arbitraryMeasurement &&
                            counterStart === true &&
                            <Item onClick={(e) => {onClickHandle('regist')}}>
                                {String(Math.floor(countTimer / 60).toString().padStart(2, "0")) + '：' + String(countTimer % 60).toString().padStart(2, "0")}
                            </Item>
                        }
                        {
                            arbitraryMeasurement &&
                            <Item onClick={(e) => {onClickHandle('finishiArbitrary')}}>完了</Item>
                        }
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Box
                            sx={{ padding: '10px 4px 0 4px', marginRight: '4px', color: arbitraryMeasurement ? "#ccc" : 'red', border: '1px solid red', borderRadius: '4px' }}
                            ><RefreshIcon
                            onClick={(e) => {onClickHandle('reset')}}
                        ></RefreshIcon>
                        </Box>
                        <Box sx={{textAlign: 'right'}}>
                            <Button
                                onClick={handleClick}
                                variant="outlined"
                                sx={{
                                    fontSize: '1.2rem',
                                    padding: '4px 0',
                                    backgroundColor: checked ? "#00CC5B" : "#D9D9D9",
                                    '&:hover': {
                                        backgroundColor: checked ? "#00CC5B" : "#D9D9D9",
                                    },
                                    '&:active': {
                                        backgroundColor: checked ? "#00CC5B" : "#D9D9D9",
                                    },
                                    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                                }}
                            >{checked ? "+" : "-"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ margin: "10px" }}>
                <Box sx={{ display: 'flex', gap: '10px', justifyContent: measurementType === '2' ? 'end' : 'space-around'}}>
                    <CountItem onClick={trafficJam}  sx={{
                        color: trafficJamStart === false ? 'black' : 'white',
                        backgroundColor: trafficJamStart === false ? '#FFF' : '#e9546b', width: '74%',
                        display: measurementType === '2' ? 'none' : 'block'
                    }}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around'}}>
                            <Box>前面<br />渋滞</Box>
                            <Box sx={{margin: '0', padding: '10px 0'}}>{displayTrafficJamTime(trafficJamTime)}</Box>
                        </Box>
                    </CountItem>
                    <CountItem onClick={sideTrafficJam} sx={{
                        color: sideTrafficJamStart === false ? 'black' : 'white',
                        backgroundColor: sideTrafficJamStart === false ? '#FFF' : '#e9546b', width: '74%',
                        display: measurementType === '2' ? 'none' : 'block'
                    }}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around'}}>
                            <Box>側A<br />渋滞</Box>
                            <Box sx={{margin: '0', padding: '10px 0'}}>{displayTrafficJamTime(sideTrafficJamTime)}</Box>
                        </Box>
                    </CountItem>
                    <CountItem sx={{ border: '2px solid #808080', color: 'black', backgroundColor: '#FFF', width: measurementType === '2' ? '40%' : '100%'}}>
                        <Box sx={{ width: '100%', display: 'flex' }}>
                            <Box sx={{margin: '0', padding: '10px'}}>合計</Box>
                            <Box>
                                <Box sx={{margin: '0', padding: measurementType === '1' ? '10px' : '0', display: measurementType === '2' ? 'none' : 'flex' }}>
                                    <Box sx={{ width: '10xp', minWidth: '10xp', maxWidth: '10xp'}}>車：</Box>
                                    <Box>{countList.car_total}</Box>
                                </Box>
                                <Box sx={{margin: '0', padding: measurementType === '2' ? '10px' : '0', display: measurementType === '1' ? 'none' : 'flex' }}>
                                    <Box sx={{ width: '10xp', minWidth: '10xp', maxWidth: '10xp'}}>人：</Box>
                                    <Box>{countList.people_total}</Box>
                                </Box>
                            </Box>
                        </Box>
                    </CountItem>
                </Box>
            </Box>
            {/* ボタンエリア */}
            <Box sx={carDisplay()}>
                {carCount().map((row: any) => (
                    <Box sx={setMargin()} key={row.label}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            "& .MuiButton-root": {
                                padding: (measurementType === "3" && isIPhone) ? "10px 8px" : "1px 8px",
                                color: "#000",
                                backgroundColor: '#C6D9F1',
                            },
                            "& .MuiButton-root:hover": {
                                color: "#000",
                                backgroundColor: '#C6D9F1'
                            },
                        }}>
                            <Button onMouseDown={() => setCount(row.standard)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ width: '100%', borderRadius: '0', fontSize: '1.2rem' }}>{getCount(row.standard)}</Typography>
                                    <Typography sx={{ width: '100%', borderRadius: '0', fontSize: '0.75rem' }}>{row.label+" 普通"}</Typography>
                                </Box>
                            </Button>
                            <Button onMouseDown={() => setCount(row.light)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ borderRadius: '0', fontSize: '1.2rem' }}>{getCount(row.light)}</Typography>
                                    <Typography sx={{ borderRadius: '0', fontSize: '0.75rem' }}>{row.label+" 軽"}</Typography>
                                </Box>
                            </Button>
                            <Button onMouseDown={() => setCount(row.large)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ borderRadius: '0', fontSize: '1.2rem' }}>{getCount(row.large)}</Typography>
                                    <Typography sx={{ borderRadius: '0', fontSize: '0.75rem' }}>{row.label+" 大型"}</Typography>
                                </Box>
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Box>
            {/* ボタンエリア年齢別 */}
            <Box sx={peopleDisplay()}>
                {peopleList().map((row: any, index: number) => (
                    <Box sx={setMargin()} key={index}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            "& .MuiButton-root": {
                                padding: (measurementType === "3" && isIPhone) ? "10px 8px" : "1px 8px",
                                color: row.label === '5M内' ? '#000000' : '#FFFFFF',
                                backgroundColor: row.label === '5M内' ? '#8EB4E3' : '#558ED5',
                            },
                            "& .MuiButton-root:hover": {
                                color: row.label === '5M内' ? '#000000' : '#FFFFFF',
                                backgroundColor: row.label === '5M内' ? '#8EB4E3' : '#558ED5',
                            },
                        }}>
                            <Button onMouseDown={() => setCount(row.male)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                                }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ fontSize: '1.2rem' }}>{getCount(row.male)}</Typography>
                                    <Typography sx={{ fontSize: '0.75rem' }}>{setLabel(row.label, index, 'left')}</Typography>
                                </Box>
                            </Button>
                            <Button onMouseDown={() => setCount(row.female)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                                }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ fontSize: '1.2rem' }}>{getCount(row.female)}</Typography>
                                    <Typography sx={{ fontSize: '0.75rem' }}>{setLabel(row.label, index, 'center')}</Typography>
                                </Box>
                            </Button>
                            <Button onMouseDown={() => setCount(row.s_b)}
                                sx={{ flexGrow: 1, margin: '2px', border: '1px solid #000', borderRadius: '0',
                                boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                                }}>
                                <Box sx={{ width: '100px' }}>
                                    <Typography sx={{ fontSize: '1.2rem' }}>{getCount(row.s_b)}</Typography>
                                    <Typography sx={{ fontSize: '0.75rem' }}>{setLabel(row.label, index, 'right')}</Typography>
                                </Box>
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Box>
            <ErrorConfirmDialog props={{
                open: errorDialogOpen,
                handleModal: setErrorDialogOpen,
                onCancel: () => {},
                onExecution: () => {},
                onCancelRegist: () => {},
                mode: "",
                body: LOCAL_CONSTANT.ERROR_MESSAGE.PLAN_AREA_ID_NOT_FOUND,
                confirmCancel: "",
                confirmOk: "",
                confirmCancelRegist: "",
            }} />
        </Box>
    );
        
}

export default TrafficVolume;
